import { DefaultFetchService } from "app/services/fetchService";

import type { GrowthOverviewGranularity, GrowthOverviewMetric } from "../const";
import { GROWTH_OVERVIEW_EXCEL_ENDPOINT } from "../const";

import {
    buildGrowthOverviewQueryParams,
    getGrowthOverviewSortBy,
    normalizeGrowthOverviewSearch,
} from "./buildGrowthOverviewQueryParams";

export const getGrowthOverviewExcelLink = (
    granularity: GrowthOverviewGranularity,
    metric: GrowthOverviewMetric,
    debouncedSearchTerm = "",
): string => {
    const fetchService = DefaultFetchService.getInstance();
    const queryParams = buildGrowthOverviewQueryParams({
        granularity,
        sortBy: getGrowthOverviewSortBy(metric),
        search: normalizeGrowthOverviewSearch(debouncedSearchTerm),
    });

    return `${GROWTH_OVERVIEW_EXCEL_ENDPOINT}?${fetchService.requestParams(queryParams)}`;
};
